// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'

import {
  Spinner,
  Warning,
  SvgIcon
} from '../../'

import { QUERY_EMPLOYER } from '../../../queries'


export const EmployerAPIAccessTableRow = ({ api, employerId, employerObj }) => {
  const values = Object.values(employerObj)

  return (
    <tr>
      <td data-label='Employer'>
        {values[0]}
      </td>
      <td data-label='Access'>
        {values[1]}
      </td>
      <td data-label='Credentials'>
        {values[1] &&
          <Query query={QUERY_EMPLOYER} variables={{ id: employerId }}>
            {({ loading, error, data }) => {
              if (loading) {
                return <Spinner size='x-small' className='slds-is-relative' />
              }

              if (error) {
                return <Warning title='API key could not be fetch'></Warning>
              }

              if (data.employer === null) {
                return '!'
              }

              const apiKey = data.employer[`${api}ApiKey`]
              return apiKey
                ? <div className='slds-grid'>
                    {`${apiKey.substring(0,7)}...`}
                    <div className='slds-col_bump-left' style={{ fill: '#687480' }}>
                      <SvgIcon
                        variant='utility'
                        symbol='copy'
                        size='small'
                        colour='inherit'
                        title='Copy API key to clipboard'
                        className='clickable-svgicon'
                      />
                    </div>
                  </div>
                : null
            }}
          </Query>
        }
      </td>
    </tr>
  )
}

EmployerAPIAccessTableRow.propTypes = {
  employerId: PropTypes.string.isRequired,
  employerObj: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-api-access-table/EmployerAPIAccessTableRow.js